import { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import {
  PermissionEnum,
  apiAbortController,
  Response,
  Currency,
  Country,
} from '@ui/src';
import api from '../../api/api';

export interface PermissionResponse {
  permissions: PermissionEnum[];
}

export const administrationDictionariesApi = api.injectEndpoints({
  endpoints: (build) => ({
    getEmployeesBaseDictionaries: build.query<any, void>({
      async queryFn(_arg, _queryApi, _extraOptions, fetchWithBQ) {
        const dictionaries = await Promise.all([
          fetchWithBQ('/v1/employees-roles-templates?take=999'),
          fetchWithBQ('/v1/employees/permissions'),
          fetchWithBQ('/v1/accounts?take=40'),
        ]);

        return dictionaries
          ? {
              data: {
                roles: dictionaries[0].data,
                allPermissions: dictionaries[1].data,
                accounts: dictionaries[2].data,
              },
            }
          : { error: { status: 'FETCH_ERROR' } as FetchBaseQueryError };
      },
    }),
    getAdministrationCountries: build.query<Response<Country>, void>({
      query: () => ({
        url: '/v1/countries?all=true',
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getActiveCurrencies: build.query<Response<Currency>, void>({
      query: () => ({
        url: '/v1/currencies?all=true&active=true',
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getEmployeesDictionaries: build.query<
      Response<{
        id: string;
        employeeRoleTemplateId: string;
        status: string;
        profile: { firstName: string; lastName: string };
      }>,
      void
    >({
      query: () => ({
        url: `/v1/employees?take=9999`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getAdministrationsPermissions: build.query<
      { data: PermissionResponse },
      void
    >({
      query: () => ({
        url: '/v1/employees/whoami',
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getEmployeesWhitelabel: build.query<
      { data: { data: { value: Record<string, string> } } },
      void
    >({ query: () => ({ url: '/v1/settings/whitelabel' }) }),
  }),
});

export const {
  useGetEmployeesBaseDictionariesQuery,
  useLazyGetEmployeesBaseDictionariesQuery,
  useLazyGetAdministrationsPermissionsQuery,
  useLazyGetEmployeesDictionariesQuery,
  useLazyGetEmployeesWhitelabelQuery,
  useGetActiveCurrenciesQuery,
  useLazyGetActiveCurrenciesQuery,
  useLazyGetAdministrationCountriesQuery,
} = administrationDictionariesApi;

export const {
  endpoints: {
    getEmployeesBaseDictionaries,
    getAdministrationsPermissions,
    getEmployeesDictionaries,
    getActiveCurrencies,
    getAdministrationCountries,
  },
} = administrationDictionariesApi;
